import React, { Component } from 'react';
import './FAQ.css';
import { GetCookie } from './utils/Common';
import { FetchData, UploadFile } from './utils/DataFetch';

export class CodeOfConduct extends Component {
  static displayName = CodeOfConduct.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      codeOfConductAccepted: false,
    };
    this.handleCodeOfConductChange = this.handleCodeOfConductChange.bind(this);
  }

  componentDidMount() {
    FetchData('/getinterpreteritems', 'POST', this.user.token, { IntId: this.user.intid }).then((data) => {
      if (Array.isArray(data) && data.some((item) => item.intItemType === 'Code of Conduct')) {
        this.setState({ codeOfConductAccepted: true });
      }
    });
  }

  async handleCodeOfConductChange(e) {
    if (!e.target.checked) return;

    const formData = new FormData();
    formData.append('EventType', 'insert');
    formData.append('IntItemId', null);
    formData.append('IntId', this.user.intid);
    formData.append('ItemName', 'Code of Conduct');
    formData.append('ItemDescription', 'Interpreter Accepted Terms and Conditions');
    formData.append('Contact', '');
    formData.append('ContactEmail', '');
    formData.append('Notes', '');
    formData.append('FileLocation', '');
    formData.append('FileName', '');
    formData.append('IntItemType', 'Code of Conduct');
    formData.append('CreateDateTime', null);
    formData.append('CreateByUserId', this.user.userid);
    formData.append('UpdateByUserId', null);
    formData.append('UpdateDateTime', null);
    formData.append('IsDeletedFlg', false);
    formData.append('FormFile', null);

    await UploadFile('/saveinterpreteritem', this.user.token, formData);
    this.setState({ codeOfConductAccepted: true });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)', padding: '20px', maxWidth: '852px', margin: '0 auto' }}>
        <h4 style={{ textAlign: 'center', marginBottom: '12px' }}>Code of Conduct</h4>
        <iframe
          src="/Interpreter_Code_of_Conduct.pdf#toolbar=0&navpanes=0&scrollbar=0"
          style={{ flex: 1, width: '100%', border: 'none' }}
          title="Code of Conduct"
        />
        <div style={{ marginTop: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
            <input
              type="checkbox"
              checked={this.state.codeOfConductAccepted}
              disabled={this.state.codeOfConductAccepted}
              onChange={this.handleCodeOfConductChange}
            />
            I have read and agree to the Code of Conduct
          </label>
        </div>
      </div>
    );
  }
}
